import React from "react";

const JQuery_Filtering = () => {
  return (
    <div>
      <h1>JQuery_Filtering</h1>
      <p>Placeholder component for: "JQuery_Filtering"</p>
    </div>
  );
};

export default JQuery_Filtering;
